
<button type="button"
        onclick="let dialogElm = window['customerLoginDialog']; dialogElm.open ? dialogElm.close() : dialogElm.showModal()"
        [attr.aria-label]="'CUSTOMER.HEADER_BUTTON_OPEN_MENU'|translate">
    @if(customerService.Current(); as customer) {
            <svg xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="#0a1f63">
                <path d="M12 12C14.7614 12 17 9.76142 17 7C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7C7 9.76142 9.23858 12 12 12Z" fill="#0a1f63"/>
                <path d="M12.0002 14.5C6.99016 14.5 2.91016 17.86 2.91016 22C2.91016 22.28 3.13016 22.5 3.41016 22.5H20.5902C20.8702 22.5 21.0902 22.28 21.0902 22C21.0902 17.86 17.0102 14.5 12.0002 14.5Z" fill="#0a1f63"/>
            </svg>
            <span>{{ customer?.username }}</span>
    } @else {
            <svg xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="transparent">
                <path d="M12 12C14.7614 12 17 9.76142 17 7C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7C7 9.76142 9.23858 12 12 12Z" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M20.5901 22C20.5901 18.13 16.7402 15 12.0002 15C7.26015 15 3.41016 18.13 3.41016 22" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
    }
</button>

<dialog id="customerMenu" onpointerleave="this.close()">
    <app-customer-menu></app-customer-menu>
</dialog>

<dialog id="customerLoginDialog" [modal]="true">
    <button class="close"
            type="button"
            onclick="this.closest('dialog').close()"
            [attr.aria-label]="'CUSTOMER.CLOSE_DIALOG'|translate">
        <app-svg use="close"></app-svg>
    </button>
    <app-customer-login (done)="close('customerLoginDialog')"></app-customer-login>
</dialog>
